import React, {createElement, useState} from 'react'
import { Swiper } from 'swiper/esm/react/swiper.js'
import { SwiperSlide } from 'swiper/esm/react/swiper-slide.js'
import SwiperCore, { Navigation } from 'swiper'
import 'swiper/swiper.scss';
import moduleCss from './index.module.scss'
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import { formatImage } from '@ifeng/public_method'
import Chip from 'Chip';

SwiperCore.use([ Navigation ])

export interface Swiper_finance_Props {
    nodeId?: string
    style?: object;
    swiperChip: TYPE_Chip;
}

const Swiper_finance: React.FC<Swiper_finance_Props> = (props) => {
    const { nodeId, style, swiperChip } = props
    const [ swiperIndex, setSwiperIndex ] = useState(0) // swiper 内部的 index

    const swiperChipData = useChip(swiperChip)
    const swiperChipComponentData = formatChip(swiperChip)

    return (
        <Chip {...swiperChipComponentData}>
            <div id={nodeId} className={moduleCss.Swiper_2} style={style}>
                <div className={moduleCss.left}>
                    <Swiper
                        style={{ width: '304px', height: '808px' }}
                        direction="vertical"
                        navigation={{
                            prevEl: `.${moduleCss.prev}`,
                            nextEl: `.${moduleCss.next}`
                        }}
                        slidesPerView={4}
                        onSlideChange={(swiper) => {
                            setSwiperIndex(swiper.realIndex)
                        }}
                    >
                        {
                            swiperChipData && swiperChipData.map((item, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <div className={`${moduleCss.swiperItem} ${swiperIndex === index ? moduleCss.active : ''}`} onClick={() => setSwiperIndex(index)}>
                                            <img src={formatImage(item.image, 280 * 2 ,161 * 2)} alt={item.title} />
                                            <div className={moduleCss.text}>
                                                <a href={item.url} target="_blank" rel="noreferrer">
                                                    {item.title}
                                                </a>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                );
                            })
                        }
                    </Swiper>
                    <div className={moduleCss.navigation}>
                        <div className={`${moduleCss.prev}`} />
                        <div className={`${moduleCss.next}`} />
                    </div>
                </div>
                {
                    swiperChipData && swiperChipData[swiperIndex] &&
                    <div className={moduleCss.right}>
                        <a href={swiperChipData[swiperIndex].url} target="_blank" rel="noreferrer">
                            <img src={swiperChipData[swiperIndex].longImage} alt={swiperChipData[swiperIndex].title} />
                        </a>
                    </div>
                }
                <Mask visible={!swiperChip.id} zIndex={3}>
                    示例结构化碎片—{swiperChip.default.id}
                </Mask>
            </div>
        </Chip>
    )
}

export default Swiper_finance
